import { PATHS, sanitizeReturnToPath } from "./routes";

const SESSION_EXPIRY_MESSAGE_KEYS = Object.freeze({
  missing_refresh_token: "sessionExpiredModal.messages.missing_refresh_token",
  login_required: "sessionExpiredModal.messages.login_required",
  consent_required: "sessionExpiredModal.messages.consent_required",
  interaction_required: "sessionExpiredModal.messages.interaction_required",
  invalid_grant: "sessionExpiredModal.messages.invalid_grant",
  session_expired: "sessionExpiredModal.messages.session_expired",
  backend_wakeup: "sessionExpiredModal.messages.backend_wakeup",
});

export const getSessionExpiryMessageKey = (reason) =>
  SESSION_EXPIRY_MESSAGE_KEYS[reason] || "sessionExpiredModal.messages.default";

const SESSION_RECOVERY_BADGE_KEYS = Object.freeze({
  backend_wakeup: "sessionExpiredModal.badges.backend_wakeup",
  missing_refresh_token: "sessionExpiredModal.badges.reconnect",
  login_required: "sessionExpiredModal.badges.reconnect",
  consent_required: "sessionExpiredModal.badges.reconnect",
  interaction_required: "sessionExpiredModal.badges.reconnect",
  invalid_grant: "sessionExpiredModal.badges.reconnect",
  session_expired: "sessionExpiredModal.badges.reconnect",
});

export const getSessionRecoveryBadgeKey = (reason) =>
  SESSION_RECOVERY_BADGE_KEYS[reason] || "sessionExpiredModal.badges.reconnect";

export const getSessionReconnectPrompt = (reason) =>
  reason === "consent_required" ? "consent" : null;

export const getLocationReturnTo = (locationLike, fallback = PATHS.root) => {
  const pathname = typeof locationLike?.pathname === "string" ? locationLike.pathname : "";
  const search = typeof locationLike?.search === "string" ? locationLike.search : "";
  const hash = typeof locationLike?.hash === "string" ? locationLike.hash : "";
  return sanitizeReturnToPath(`${pathname}${search}${hash}`, fallback);
};

export const buildAuthRedirectOptions = ({
  returnTo,
  prompt = null,
  fallback = PATHS.root,
} = {}) => {
  const safeReturnTo = sanitizeReturnToPath(returnTo, fallback);
  const options = {};

  if (safeReturnTo && safeReturnTo !== PATHS.root) {
    options.appState = { returnTo: safeReturnTo };
  }

  if (prompt) {
    options.authorizationParams = { prompt };
  }

  return options;
};
